import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaChevronRight } from 'react-icons/fa';
import '../css/Breadcrumbs.css';

const routeNameMap = {
  '/': 'Trang chủ',
  '/login': 'Đăng nhập',
  '/register': 'Đăng ký',
  '/request': 'Yêu cầu mượn xe',
  '/approval': 'Phê duyệt yêu cầu',
  '/return': 'Trả xe',
  '/incident': 'Báo cáo sự cố',
  '/incident-reports': 'Danh sách sự cố',
  '/report': 'Báo cáo',
  '/add-vehicle': 'Thêm xe mới',
  '/profile': 'Hồ sơ cá nhân',
  '/return-reports': 'Báo cáo trả xe',
  '/human-resources': 'Quản lý nhân sự',
  '/vehicle-management': 'Quản lý xe',
  '/vehicle-qr-management': 'QR Code Xe',
  '/vehicle-qr/:vehicleId': 'Chi tiết QR Xe',
  '/uploads': 'Uploads',
  '/work-journal': 'Nhật ký công việc',
  '/reception': 'Tiếp tân',
  '/guide': 'Hướng dẫn sử dụng',
  '/admin-work-management': 'Phạm vi công việc',
  '/support': 'Hỗ trợ',
  '/support-admin': 'Quản lý hỗ trợ',
  '/my-support-requests': 'Yêu cầu hỗ trợ của tôi',
  '/asset-management': 'Quản lý tài sản',
  '/superadmin': 'Quản trị viên',
  '/create-user': 'Tạo người dùng mới',
  '/all-notifications': 'Tất cả thông báo',
  '/test-notifications': 'Test thông báo',
  '/driver-profiles': 'Hồ sơ tài xế',
  '/driver-schedule': 'Lịch trình tài xế',
  '/all-driver-schedules': 'Quản lý lịch trình tài xế',
  '/leave-request': 'Đơn nghỉ phép',
  '/leave-request/create': 'Tạo đơn nghỉ phép',
  '/leave-requests': 'Đơn nghỉ phép',
  '/activity-logs': 'Nhật ký hoạt động',
  '/admin-notifications': 'Quản lý thông báo',
  '/admin/driver-management': 'Quản lý tài xế',
  '/fuel-management': 'Quản lý nhiên liệu',
  '/admin/announcements': 'Quản lý thông báo',
  '/announcements': 'Thông báo',
  '/privacy-policy': 'Chính sách bảo mật',
  '/todos': 'Sổ tay việc làm',
  '/company-documents': 'Tài liệu công ty',
  '/employee-evaluations': 'Đánh giá nhân viên',
  '/online-users': 'Người dùng trực tuyến',
  '/page-visibility': 'Hiển thị trang',
  '/notification-settings': 'Cài đặt thông báo',
  '/recruitment-dashboard': 'Bảng điều khiển tuyển dụng',
  '/recruitment-requests': 'Yêu cầu tuyển dụng',
  '/candidates': 'Ứng viên',
  '/interviews': 'Phỏng vấn',
  '/complete-profile': 'Hoàn thành hồ sơ',
  '/attendance-management': 'Quản lý chấm công',
  '/performance-management': 'Quản lý hiệu suất',
  '/super-admin/user-management': 'Quản lý người dùng',
  '/link-management': 'Quản lý liên kết',
  '/pickup-schedules': 'Quản lý lịch đón khách',
  '/probationary-management': 'Quản lý thử việc',
  '/birthdays': 'Sinh nhật',
  '/pdf-management': 'Quản lý PDF',
  '/software-rating-management': 'Quản lý đánh giá phần mềm',
  '/system-status': 'Trạng thái hệ thống',
  '/health-check': 'Kiểm tra sức khỏe hệ thống',
  '/audit-trail': 'Nhật ký kiểm toán',
  '/cron-dashboard': 'Quản lý tác vụ định kỳ',
  '/backup-manager': 'Quản lý sao lưu',
  '/executive-dashboard': 'Tổng quan doanh nghiệp',
  '/push-notifications': 'Quản lý thông báo đẩy',
  '/contract': 'Hợp đồng',
  '/labor-contract': 'Hợp đồng lao động',
  '/benefits-management': 'Quản lý phúc lợi',
  '/salary-management': 'Quản lý lương',
  '/admin': 'Quản trị',
  '/super-admin': 'Quản trị viên',
  '/ai-chat': 'Trợ lý AI'
};

// Các route có thể có tham số động
const dynamicRoutes = [
  { pattern: /^\/vehicle-management\/(\w+)$/, name: 'Chi tiết xe', parent: '/vehicle-management' },
  { pattern: /^\/driver-profiles\/(\w+)$/, name: 'Chi tiết tài xế', parent: '/driver-profiles' },
  { pattern: /^\/support\/(\w+)$/, name: 'Chi tiết hỗ trợ', parent: '/support' },
  { pattern: /^\/incident-reports\/(\w+)$/, name: 'Chi tiết sự cố', parent: '/incident-reports' },
  { pattern: /^\/return-reports\/(\w+)$/, name: 'Chi tiết trả xe', parent: '/return-reports' },
  { pattern: /^\/leave-request\/create$/, name: 'Tạo đơn nghỉ phép', parent: null }, // Không hiển thị parent
  { pattern: /^\/employee-evaluations\/(\w+)$/, name: 'Chi tiết đánh giá', parent: '/employee-evaluations' }
];

const Breadcrumbs = () => {
  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  const handleLinkClick = (targetPath = null) => {
    // Refresh CSS similar to navbar functionality
    const refreshCSS = () => {
      const existingLinks = document.querySelectorAll('link[href*="template-navbar.css"]');
      existingLinks.forEach(link => link.remove());
      const linkElement = document.createElement('link');
      linkElement.rel = 'stylesheet';
      linkElement.href = `/css/template-navbar.css?v=${new Date().getTime()}`;
      document.head.appendChild(linkElement);
    };

    refreshCSS();
    setTimeout(refreshCSS, 100);

    // Auto-reload functionality for all pages
    if (targetPath !== null) {
      // If already on target page, reload immediately
      if (location.pathname === targetPath) {
        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else {
        // If not on target page, wait for navigation then reload
        setTimeout(() => {
          if (window.location.pathname === targetPath) {
            window.location.reload();
          }
        }, 300);
      }
    }
  };

  useEffect(() => {
    const pathSegments = location.pathname.split('/').filter(segment => segment);
    let accumulatedPath = '';
    const breadcrumbsArray = [];

    // Luôn thêm trang chủ vào đầu breadcrumbs
    breadcrumbsArray.push({
      path: '/',
      name: 'Trang chủ',
      icon: <FaHome />
    });

    // Xử lý các route động
    let isDynamicRoute = false;
    for (const route of dynamicRoutes) {
      if (route.pattern.test(location.pathname)) {
        isDynamicRoute = true;
        // Thêm trang cha
        if (route.parent) {
          breadcrumbsArray.push({
            path: route.parent,
            name: routeNameMap[route.parent] || route.parent.substring(1)
          });
        }
        // Thêm trang hiện tại
        breadcrumbsArray.push({
          path: location.pathname,
          name: route.name
        });
        break;
      }
    }

    // Nếu không phải route động, xử lý theo cách thông thường
    if (!isDynamicRoute && pathSegments.length > 0) {
      pathSegments.forEach((segment, index) => {
        accumulatedPath += `/${segment}`;
        const name = routeNameMap[accumulatedPath] || segment.charAt(0).toUpperCase() + segment.slice(1);

        breadcrumbsArray.push({
          path: accumulatedPath,
          name: name
        });
      });
    }

    setBreadcrumbs(breadcrumbsArray);
  }, [location]);

  // Không hiển thị breadcrumbs ở trang chủ hoặc trang đăng nhập
  if (location.pathname === '/' || location.pathname === '/login') {
    return null;
  }

  return (
    <div className="breadcrumbs-container">
      <div className="breadcrumbs">
        {breadcrumbs.map((breadcrumb, index) => (
          <React.Fragment key={breadcrumb.path}>
            {index > 0 && <FaChevronRight className="breadcrumb-separator" />}
            {index === breadcrumbs.length - 1 ? (
              <span className="breadcrumb-current">
                {breadcrumb.icon} {breadcrumb.name}
              </span>
            ) : (
              <Link
                to={breadcrumb.path}
                className="breadcrumb-link"
                onClick={() => handleLinkClick(breadcrumb.path)}
              >
                {breadcrumb.icon} {breadcrumb.name}
              </Link>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Breadcrumbs;